import { NgModule }           from '@angular/core';
import { NgxCsvParserModule } from 'ngx-csv-parser';

import { BigDecimalService }       from './big-decimal.service';
import { BoxTogglerService }       from './box-toggler.service';
import { CSVService }              from './csv.service';
import { CurrencyService }         from './currency.service';
import { DateParserService }       from './date-parser.service';
import { DomainParserService }     from './domain.parser.service';
import { FormActionsStuckService } from './form-actions-stuck.service';
import { JsonService }             from './json.service';
import { PruneService }            from './prune.service';
import { WindowService }           from './window.service';

@NgModule({
  imports: [
    NgxCsvParserModule
  ],
  providers: [
    BigDecimalService,
    BoxTogglerService,
    CSVService,
    CurrencyService,
    DateParserService,
    DomainParserService,
    FormActionsStuckService,
    JsonService,
    PruneService,
    WindowService
  ]
})
export class ServicesModule {
  // Injected only so the service starts with the app.
  constructor ( formActionsStuck : FormActionsStuckService ) {}
}
